import { RecordDataCommand, RecordDataCommandParams, TaskCommand } from "@app/shared";
import { useModel } from "../../../hooks";
import { EnumSelect, InputRow, NumericInput } from "../inputs";
import { DeviceCommandEditorProps } from "./DeviceCommandEditor";

type EditRecordDataCommandProps = {
} & DeviceCommandEditorProps;

export const EditRecordDataCommand: React.FC<EditRecordDataCommandProps> = (props) => {
    const [, paramsHelper] = useModel(RecordDataCommandParams, (props.command as RecordDataCommand).commandParamsJson);
    const onChange = (newParams: Partial<RecordDataCommandParams>) => {
        props.onChange({ ...props.command, commandParamsJson: newParams } as RecordDataCommand);
    };
    return (
        <>
            <InputRow><EnumSelect label="Command" enumType={TaskCommand} {...paramsHelper.bindingsFor("command", onChange)} /></InputRow>
            <InputRow><NumericInput label="Duration (Hours)" allowFloat={false} {...paramsHelper.bindingsFor("durationHours", onChange)} /></InputRow>
            <InputRow><NumericInput label="Duration (Minutes)" allowFloat={false} {...paramsHelper.bindingsFor("durationMinutes", onChange)} /></InputRow>
        </>
    );
}